import { z } from 'zod';

import type { AlignmentStep } from '../../data-contract/position-alignment';

export const alignmentPageStepSchema = z.enum(['overview', 'position', 'tasks', 'automations']);

export type AlignmentPageStep = z.infer<typeof alignmentPageStepSchema>;

export const ALIGNMENT_PAGE_STEPS: readonly AlignmentPageStep[] = alignmentPageStepSchema.options;

const CONTRACT_STEP: Readonly<Record<AlignmentPageStep, AlignmentStep | null>> = {
    automations: 'AUTOMATIONS',
    overview: null,
    position: 'POSITION',
    tasks: 'TASKS',
};

const PAGE_STEP: Readonly<Record<AlignmentStep, AlignmentPageStep>> = {
    AUTOMATIONS: 'automations',
    POSITION: 'position',
    TASKS: 'tasks',
};

export const pageStepOf = (value: string | null): AlignmentPageStep =>
    ALIGNMENT_PAGE_STEPS.find((step) => step === value) ?? 'overview';

export const contractStepOf = (step: AlignmentPageStep): AlignmentStep | null => CONTRACT_STEP[step];

export const pageStepFor = (step: AlignmentStep): AlignmentPageStep => PAGE_STEP[step];
